import React from "react";
import JobOpertunites from "./JobOpertunites";
import DailyChallengeCard from "./DailyChallengeCard";

function SectionTwoWrapper() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
      <DailyChallengeCard />
      <JobOpertunites />
    </div>
  );
}

export default SectionTwoWrapper;
